import API from "../config/api.js";

export const RequisitionService = {
  getBranches() {
    return API.get("/api/inventory/branches");
  },

  getProducts(searchTerm = "") {
    return API.get(`/api/inventory/products`, {
      params: {
        search: searchTerm,
      },
    });
  },

  createRequisition(data) {
    return API.post("/api/requisitions/create", data);
  },

  updateRequisition(id, data) {
    return API.put(`/api/requisitions/update/${id}`, data);
  },

  getRequisitions(searchTerm = "", branchId, storeIds, page = 1) {
    return API.get("/api/requisitions", {
      params: {
        search: searchTerm,
        branch_id: branchId,
        store_ids: storeIds && storeIds.length ? storeIds.join(",") : undefined, // store_ids=2,3
        page: page,
      },
    });
  },

  async deleteRequisition(id) {
    try {
      await API.delete(`/api/requisitions/delete/${id}`);
    } catch (error) {
      console.error("Error deleting requisition:", error);
      throw error; // Re-throwing the error to be handled in the component
    }
  },

  getRequisitionDetails(id) {
    return API.get(`/api/requisitions/info/${id}`);
  },

  getRequisitionDetailsWithStocks(id, branchId, storeIds) {
    return API.get(`/api/requisitions/info-with-stocks/${id}`, {
      params: {
        branch_id: branchId,
        store_ids: storeIds && storeIds.length ? storeIds.join(",") : undefined, // store_ids=2,3
      },
    });
  },

  updateRequisitionStatus(id, status) {
    return API.put(`/api/requisitions/update-status/${id}`, { status });
  },
};
